import { AspectRatio, Flex, GridItem, Image, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import { BenefitPrize } from '~/types/resources/benefitPrize';
import { GrantedBenefit } from '~/types/resources/grantedBenefit';

type Props = {
  benefitPrize: BenefitPrize;
  grantedBenefits: GrantedBenefit[];
  benefitOnOpen: () => void;
  setBenefitPrize: (newBenefitPrize: BenefitPrize) => void;
};

export const CollectionBenefitItem: React.FC<Props> = (props: Props) => {
  const grantedBenefit = props.grantedBenefits.find((grantedBenefit) => {
    return grantedBenefit.benefit.id == props.benefitPrize.id;
  });
  const quantity: string | null = useMemo(() => {
    if (grantedBenefit == null) return null;
    if (grantedBenefit.quantity > 99) {
      return '99+';
    }
    if (grantedBenefit.quantity < 1) {
      return null;
    }
    return grantedBenefit.quantity.toString();
  }, [grantedBenefit]);

  const imageUrl = useMemo(() => {
    if (quantity == null) return props.benefitPrize.thumbnail_image_url;
    if (grantedBenefit?.benefit?.secret_image_url != '')
      return grantedBenefit?.benefit?.secret_image_url;
    return grantedBenefit?.benefit?.image_url;
  }, [props.benefitPrize, grantedBenefit, quantity]);

  return (
    <GridItem
      onClick={() => {
        props.setBenefitPrize(props.benefitPrize);
        props.benefitOnOpen();
      }}
      as="label"
      p="8px"
      position="relative"
      opacity={quantity != null ? 1 : 0.35}
    >
      <AspectRatio ratio={1 / 1}>
        <Image
          src={imageUrl}
          alt={`${props.benefitPrize.name}の画像`}
          loading="lazy"
          pointerEvents="none"
        />
      </AspectRatio>
      {quantity != null && (
        <Flex
          rounded="50px"
          bgColor="main"
          minW="20px"
          maxW="40px"
          px="4px"
          zIndex={2}
          right={0}
          bottom={0}
          position="absolute"
          align="center"
          justify="center"
        >
          <Text fontSize="12px" lineHeight="20px" color="white">
            {quantity}
          </Text>
        </Flex>
      )}
    </GridItem>
  );
};
